const selectAll = e => e.target.select();
export default selectAll;
